import {Component, OnInit, Input, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-product-petal',
  templateUrl: './product-petal.component.html',
  styleUrls: ['./product-petal.component.scss'],
})
export class ProductPetalComponent implements OnInit {
  @Input() size = 'small';
  @Input() color: string;
  @Input() text: any;

  sizeSvg = '1.5rem';
  isBrowser;

  constructor(@Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
  }

  ngOnInit() {
    if (this.isBrowser) {
      if (this.size === 'md') {
        this.sizeSvg = this.validateWidth(2.5);
      } else if (this.size === 'mini') {
        this.sizeSvg = this.validateWidth(1.5);
      }
    }
  }

  validateWidth(option) {
    if (window.screen.width <= 990) {
      return `${option - 0.5}rem`;
    }
    return `${option}rem`;
  }
}
